module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNiA0Ij48cGF0aCBmaWxsPSIjMDBBNTUxIiBkPSJNMCAwaDZ2NEgweiIvPjxwYXRoIGZpbGw9IiNGRkQ1MDAiIGQ9Ik0wIDBoNnYzSDB6Ii8+PHBhdGggZmlsbD0iIzFBMjA2RCIgZD0iTTAgMGg2djJIMHoiLz48cGF0aCBmaWxsPSIjRUEyODM5IiBkPSJNMCAwaDZ2MUgweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/mus.svg
// module id = W1bk
// module chunks = 0